import {
	FILTER_CLEAR,
	FILTER_IS_OPEN,
	FILTER_LANGUAGE,
	FILTER_SELECTED_TOPICS,
	FILTER_OPEN_CATEGORIES,
	FILTER_SELECTED_CATEGORIES,
} from '../types/filter';

export const clearFilter = (filterIds) => {
	return {
		type: FILTER_CLEAR,
		filterIds,
	};
};

export const setFilterIsOpen = (filterIsOpen, filterId) => {
	return {
		type: FILTER_IS_OPEN,
		filterIsOpen,
		filterId,
	};
};

export const setFilterLanguage = (currentLanguage, filterId) => {
	return {
		type: FILTER_LANGUAGE,
		currentLanguage,
		filterId,
	};
};

export const setOpenCategories = (openCategories, filterId) => {
	return {
		type: FILTER_OPEN_CATEGORIES,
		openCategories,
		filterId,
	};
};

export const setSelectedCategories = (selectedCategories, filterId) => {
	return {
		type: FILTER_SELECTED_CATEGORIES,
		selectedCategories,
		filterId,
	};
};

export const setSelectedTopics = (selectedTopics, filterId) => {
	return {
		type: FILTER_SELECTED_TOPICS,
		selectedTopics,
		filterId,
	};
};
